




















































import { Component, Inject, Vue, Watch } from 'vue-property-decorator'
import {
  setLocale,
  removeToken,
  getToken,
  getRoleType,
  setRoleType,
  removeRoleType,
  getLocale,
} from '@/utils/utils'
import { RouteRecord } from 'vue-router'
import {
  MemberController,
  TraceController,
  NoticeController,
  SchoolController,
} from '@/services/request.service'
import PCMenu from '@/components/PCMenu.vue'
const defaultLogo = require('@/assets/images/logo.png')

@Component({
  components: {
    PCMenu,
  },
})
export default class Main extends Vue {
  @Inject() public readonly reloadPage!: any

  @Watch('$route', { immediate: true })
  public onRouteChanged(to: any, from: any) {
    const token = getToken()
    if (!token) {
      this.logout()
    }
  }

  public get roleType(): string {
    return this.$store.state.roleType
  }

  public get routes(): Array<any> {
    const router = this.$route as any
    return router.matched.filter((item: RouteRecord) => item.meta && item.meta.routerName)
  }

  public get contentHeaderShow(): boolean {
    return !this.$route.meta.rootPage
  }

  public get logo(): any {
    return defaultLogo
  }

  public created(): void {
    this.getUserInfo()
    const locale = getLocale()
    this.$store.commit('changeLocale', locale)
  }

  public getUserInfo(): void {
    MemberController.queryUserInfo()
      .then(res => {
        this.$store.commit('setUserInfo', {
          username: res.data.enName + ' ' + res.data.name,
          memberId: res.data.memberId,
          avatar: res.data.avatarUrl,
        })
        this.$store.commit('setRoleType', res.data.roleType)
        setRoleType(res.data.roleType)
      })
      .catch(err => {
        console.warn(err)
      })
  }

  public openPersonal(): void {
    this.$router.push({ name: 'personal' }).catch(err => {})
  }

  public changeLocale(): void {
    const currentLocale = this.$i18n.locale
    if (currentLocale === 'zh') {
      this.$i18n.locale = 'en'
      this.$store.commit('changeLocale', 'en')
      setLocale('en')
    } else if (currentLocale === 'en') {
      this.$i18n.locale = 'zh'
      this.$store.commit('changeLocale', 'zh')
      setLocale('zh')
    }
  }

  public logout(): void {
    removeToken()
    removeRoleType()
    this.$store.commit('changeForceBack', true)
    this.$router.push({ name: 'login' }).catch(err => {})
  }
}
